import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import comercio from './comercio'
import factibilidad from './factibilidad'
import aeropuerto from './aeropuerto'
import bomberos from "./bomberos";
import metro from "./metro";
import configuracion from "./configuracion";

Vue.use(Vuex);

export default new Vuex.Store({
    plugins: [createPersistedState({
        storage: window.sessionStorage,
    })],
    state: {
        configuracionCliente: null,
        transaccion: null,
        transaccionIdH2H: null,
        token: null,
        transaccionCliente: null,
        estado: null,
        estadoTransaccion: false,
        rutMiClub: null,
        statusMiClub: null,
        bloquear: false,
        urlBaseS3: "https://cdn.movired.cl",
        configuracionClienteBase: {
            cliente: "$2y$10$7bcBAw75UXAveIV4FkBvx.yUVlCfjerPW8HZ6RhMAVTAovKHQjSZG",
            navigation_url: "/",
            productos: [
                {
                    producto: 1,
                    identificador: 1,
                    nombre: "CONSULTA DE SALDO"
                },
                {
                    producto: 34,
                    identificador: 2,
                    nombre: "bip!QR"
                },
                {
                    producto: 35,
                    identificador: 3,
                    nombre: "Tarjeta bip!"
                },
                {
                    producto: 2,
                    identificador: 104,
                    nombre: "ABONO COMERCIOS"
                }
            ],
            metodos_pago: [
                1,
                2
            ],
            pagina: {
                url_logo_header: "/header/logo-movired-rojo.png",
                url_logo_footer: "/footer/logo-movired-blanco.png",
                url_logo_general_trx: "/confirmacion/header/logo-movired.png",
                color_menu_post_header: "#c30030",
                color_botonera_activa: "#c30030",
                telefono: "600 473 40 33",
                correo_contacto: "soporte@movired.cl",
                horarios: "lun - vie: 7:30 a 18:30 hrs.",
                social_instagram: "https://www.instagram.com/moviredcl/",
                social_facebook: "https://www.facebook.com/movired.cl",
                social_linkedin: "https://www.linkedin.com/company/moviredcl/",
                social_twitter: "https://twitter.com/moviredcl"
            }
        }
    },
    mutations: {
        actualizarCliente(state, configuracion) {
            state.configuracionCliente = configuracion;
        },
        actualizarEstado(state, estado) {
            state.estado = estado;
        },
        actualizarEstadoTransaccion(state, estado) {
            state.estadoTransaccion = estado;
        },
        actualizarTransaccion(state, transaccion) {
            state.transaccion = transaccion;
        },
        actualizarTransaccionH2H(state, transaccion) {
            state.transaccionIdH2H = transaccion;
        },
        actualizarToken(state, token) {
            state.token = token;
        },
        actualizarTransaccionCliente(state, transaccionCliente) {
            state.transaccionCliente = transaccionCliente;
        },
        actualizarRutMiClub(state, rut) {
            state.rutMiClub = rut;
        },
        bloquearTrue(state) {
            state.bloquear = true;
        },
        bloquearFalse(state) {
            state.bloquear = false;
        },
        actualizarStatusMiClub(state, status) {
            state.statusMiClub = status;
        },
    },
    actions: {
        actualizarStatusMiClub({
            commit
        }, payload) {
            commit("actualizarStatusMiClub", payload.status);
        },
        actualizarConfiguracionCliente({
            commit
        }, payload) {
            commit("actualizarCliente", payload);
        },
        actualizarEstado({
            commit
        }, payload) {
            commit("actualizarEstado", payload.estado);
        },
        actualizarEstadoTransaccion({
            commit
        }, payload) {
            commit("actualizarEstadoTransaccion", payload.estadoTransaccion);
        },
        actualizarTransaccionH2HRecibida({
            commit
        }, payload) {
            commit("actualizarTransaccionH2H", payload.transaccionH2H);
        },
        actualizarRutMiClub({
            commit
        }, payload) {
            commit("actualizarRutMiClub", payload.rutMiClub);
        },
        actualizarTransaccionRecibida({
            commit
        }, payload) {
            commit("actualizarTransaccion", payload.transaccion);
            commit("actualizarToken", payload.token);
            commit("actualizarTransaccionCliente", payload.transaccionCliente);
        },
        resetearDatos({
            commit
        }) {
            commit("actualizarTransaccion", null);
            commit("actualizarTransaccionH2H", null);
            commit("actualizarToken", null);
            commit("actualizarTransaccionCliente", null);
            commit("actualizarEstado", null);
            commit("actualizarEstadoTransaccion", false)
            commit("actualizarRutMiClub", null)
            commit("bloquearFalse")
            commit("actualizarStatusMiClub", null)
            commit("actualizarCliente", null)
        },
        resetearDatosAeropuerto({
            commit
        }) {
            commit("actualizarTransaccion", null);
            commit("actualizarTransaccionH2H", null);
            commit("actualizarToken", null);
            commit("actualizarTransaccionCliente", null);
            commit("actualizarEstado", null);
            commit("actualizarEstadoTransaccion", false)
            commit("actualizarRutMiClub", null)
            commit("bloquearFalse")
            commit("actualizarStatusMiClub", null)
        }
    },
    modules: {
        comercio,
        factibilidad,
        aeropuerto,
        bomberos,
        metro,
        configuracion
    }
});
